import { integrationResourcesApi } from '../api/IntegrationResourcesApi'
import type { ProviderAccount, ProviderAccountParams } from '../models/integrationResources.types'

import { useWorkspace } from '@/features/account'

export interface UseProviderAccounts {
  fetchAccounts: (
    endpoint: string,
    params?: ProviderAccountParams,
    signal?: AbortSignal,
  ) => Promise<ProviderAccount[]>
}

export function useProviderAccounts(): UseProviderAccounts {
  const { workspaceId } = useWorkspace()

  return {
    fetchAccounts(endpoint, params, signal) {
      const selectedWorkspaceId = workspaceId.value
      if (selectedWorkspaceId === undefined) {
        return Promise.reject(new Error('Provider account access requires an active workspace'))
      }
      return integrationResourcesApi.fetchAccounts(selectedWorkspaceId, endpoint, params, signal)
    },
  }
}
